export enum TagEnum {
	MAJOR = 1,
	TEAM = 2,
}

export interface IAddTag {
	name: string;
	icon?: string;
	desc?: string;
}
export type IListTag = {
	id: string;
} & IAddTag;

export type ITag = {
	type: TagEnum;
} & IListTag;
